module.exports = __webpack_public_path__ + "static/media/richBehavior.02a57e34.svg";